"use strict";

exports.__esModule = true;
exports.TicketDetailsEditMode = TicketDetailsEditMode;
var _react = _interopRequireDefault(require("react"));
var _icons = require("@blueprintjs/icons");
var _reactFinalForm = require("react-final-form");
var _core = require("@blueprintjs/core");
var _DetailsComponent = require("../../Core/DetailsComponent");
var _DeviceListContext = require("../../Device/DeviceListContext");
var _Utils = require("../../../Utils");
var _TicketComments = require("./TicketComments");
var _AssigneeSection = require("./AssigneeSection");
var _CreatedAtSection = require("./CreatedAtSection");
var _Translator = require("../../Core/Translator");
var _EditDevicesSection = require("./EditDevicesSection");
var _EditDeviceTagsSection = require("./EditDeviceTagsSection");
var _EditTypesSection = require("./EditTypesSection");
var _EditTitleSection = require("./EditTitleSection");
var _CreatorSection = require("./CreatorSection");
var _WatchersSection = require("./WatchersSection");
var _TicketNumberSection = require("./TicketNumberSection");
var _StatusHistorySection = require("./StatusHistorySection");
var _EditPrioritySection = require("./EditPrioritySection");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function TicketDetailsEditMode(props) {
  var deviceList = _react["default"].useContext(_DeviceListContext.DeviceListContext);
  var _React$useContext = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext.translate;
  var ticketDetails = props.ticketDetails,
    ticketTypes = props.ticketTypes,
    filteredTicketTypes = props.filteredTicketTypes,
    updateTicketDetails = props.updateTicketDetails,
    setEditMode = props.setEditMode,
    width = props.width,
    height = props.height,
    isFullScreen = props.isFullScreen;
  var devices = ticketDetails.devices,
    title = ticketDetails.title,
    tags = ticketDetails.tags,
    type = ticketDetails.type,
    created = ticketDetails.created,
    creator = ticketDetails.creator,
    assignee = ticketDetails.assignee,
    assigneeId = ticketDetails.assigneeId,
    watchers = ticketDetails.watchers,
    comments = ticketDetails.comments,
    userId = ticketDetails.userId,
    history = ticketDetails.history,
    id = ticketDetails.id,
    _ticketDetails$priori = ticketDetails.priority,
    priority = _ticketDetails$priori === void 0 ? "Medium" : _ticketDetails$priori;
  var onSubmit = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(values) {
      var updateTicketDetails, devices, tags, type, output;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            updateTicketDetails = props.updateTicketDetails;
            devices = [];
            tags = [];
            type = [];
            if (values.devices && values.devices.length > 0) {
              devices = values.devices.map(function (device) {
                return {
                  type: "UUID",
                  value: device.uuid
                };
              });
            }
            if (values.tags && values.tags.length > 0) {
              tags = values.tags.map(function (tag) {
                return {
                  type: "TAG",
                  value: tag
                };
              });
            }
            if (values.type && values.type.length > 0) {
              type = values.type.map(function (type) {
                return type.id;
              });
            }
            output = {
              title: values.title,
              devices: [].concat(devices, tags),
              priority: values.priority,
              type: type
            };
            return _context.a(2, updateTicketDetails(output));
        }
      }, _callee);
    }));
    return function onSubmit(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var initialDevicesValues = devices.filter(function (device) {
    return !!device;
  }).map(function (device) {
    return (0, _Utils.getDeviceByName)(deviceList, device);
  });
  var selectedTypes = ticketTypes.filter(function (t) {
    return type.includes(t.id);
  });
  var enabledTicketTypes = ticketTypes.filter(function (t) {
    return t.enabled;
  });
  var style = {
    maxHeight: isFullScreen ? "unset" : "50px",
    overflow: "auto"
  };
  var ticketDetailsCenterContent = function ticketDetailsCenterContent() {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_EditDevicesSection.EditDevicesSection, {
      style: style,
      deviceList: deviceList
    }), /*#__PURE__*/_react["default"].createElement(_EditDeviceTagsSection.EditDeviceTagsSection, {
      style: style
    }), /*#__PURE__*/_react["default"].createElement(_EditTypesSection.EditTypesSection, {
      style: style,
      ticketTypes: enabledTicketTypes,
      filteredTicketTypes: filteredTicketTypes
    }), /*#__PURE__*/_react["default"].createElement(_EditPrioritySection.EditPrioritySection, {
      style: style
    }), /*#__PURE__*/_react["default"].createElement(_WatchersSection.WatchersSection, {
      muted: true,
      watchers: watchers
    }));
  };
  var ticketDetailsContent = function ticketDetailsContent(isFullScreen) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_DetailsComponent.DetailsSection, null, /*#__PURE__*/_react["default"].createElement(_TicketNumberSection.TicketNumberSection, {
      id: id,
      isFullScreen: isFullScreen
    }), /*#__PURE__*/_react["default"].createElement(_EditTitleSection.EditTitleSection, null), /*#__PURE__*/_react["default"].createElement(_CreatedAtSection.CreatedAtSection, {
      created: created,
      muted: true
    }), /*#__PURE__*/_react["default"].createElement(_CreatorSection.CreatorSection, {
      muted: true,
      creator: creator
    }), /*#__PURE__*/_react["default"].createElement(_AssigneeSection.AssigneeSection, {
      assignee: assignee,
      disabled: true,
      muted: true,
      assigneeId: assigneeId,
      userId: userId
    }), /*#__PURE__*/_react["default"].createElement(_StatusHistorySection.StatusHistorySection, {
      statusChangeHistory: history,
      disabled: true,
      muted: true
    })), isFullScreen ? /*#__PURE__*/_react["default"].createElement(_DetailsComponent.DetailsSection, null, ticketDetailsCenterContent()) : /*#__PURE__*/_react["default"].createElement(_DetailsComponent.DetailsSectionWide, null, ticketDetailsCenterContent()));
  };
  return /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Form, {
    initialValues: {
      devices: initialDevicesValues,
      type: selectedTypes,
      priority: priority,
      title: title,
      tags: tags
    },
    onSubmit: onSubmit
  }, function (_ref2) {
    var handleSubmit = _ref2.handleSubmit,
      pristine = _ref2.pristine,
      invalid = _ref2.invalid,
      submitting = _ref2.submitting;
    return /*#__PURE__*/_react["default"].createElement("form", {
      style: {
        width: "100%"
      },
      onSubmit: handleSubmit
    }, /*#__PURE__*/_react["default"].createElement(_DetailsComponent.DetailsContainer, {
      width: width,
      height: height,
      isFullScreen: isFullScreen
    }, /*#__PURE__*/_react["default"].createElement(_DetailsComponent.DetailsHeader, {
      showRightAligned: true,
      isFullScreen: isFullScreen
    }, /*#__PURE__*/_react["default"].createElement(_DetailsComponent.HeaderButtonGroup, {
      isFullScreen: isFullScreen
    }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
      type: "submit",
      icon: _icons.IconNames.TICK,
      loading: submitting,
      disabled: pristine || invalid,
      text: translate("TicketDetailsEditForm.update.button", "Update Ticket")
    }), /*#__PURE__*/_react["default"].createElement(_core.Button, {
      type: "button",
      icon: _icons.IconNames.CROSS,
      onClick: function onClick() {
        return setEditMode(false);
      },
      text: translate("TicketDetailsEditForm.cancel", "Cancel")
    }))), /*#__PURE__*/_react["default"].createElement(_DetailsComponent.DetailsSectionWrapper, {
      isFullScreen: isFullScreen
    }, isFullScreen ? /*#__PURE__*/_react["default"].createElement("div", null, ticketDetailsContent(isFullScreen)) : ticketDetailsContent(isFullScreen), /*#__PURE__*/_react["default"].createElement(_DetailsComponent.DetailsCommentsSection, null, /*#__PURE__*/_react["default"].createElement(_TicketComments.TicketComments, {
      disabled: true,
      comments: comments,
      ticketId: ticketDetails.id,
      onChange: updateTicketDetails,
      onSubmit: function onSubmit() {},
      isFullScreen: isFullScreen,
      onCommentEdit: function onCommentEdit() {},
      onCommentDelete: function onCommentDelete() {}
    })))));
  });
}